/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const icp_chain_about = () => `The Internet Computer enables you to build anything without traditional IT and Big Tech. It hosts decentralized serverless compute that’s simpler, immune to cyber attack, unstoppable, and controllable by DAOs. Next-generation smart contracts (named Canisters) that hold both code and state enable truly Decentralized AI. Canisters use Chain Fusion technology to write transctions directly to other chains without centralized bridges, enabling secure multi-chain dapps. Build social, defi, games, e-commerce, enterprise or any kind of application or service on ICP. The internet is evolving.`
